export const featureToColor: { [key: string]: string } = {
  // UNKNOWN: '#3d3935dd',
  UNKNOWN: '#ffffff',
  water: '#afc4db',
  riverbank: '#afc4db',
  ocean: '#afc4db',
  building: '#cecfbe',
  building_part: '#cecfbe',
  garden: '#6a9e82',
  aerodrome: '#3c4142',
  commercial: '#c7d2d6',
  parking: '#333236',
  forest: '#006e04',
  park: '#4B9E4E',
  natural_wood: '#245B00',
  nature_reserve: '#bd9a6f',
  grass: '#a7ff99',
  grassland: '#a7ff99',
  farmland: '#e3d198',
  allotments: '#accf9b',
  meadow: '#d5db8c',
  wetland: '#677329',
  residential: '#9c9789',
  cemetery: '#282854',
  grave_yard: '#282854',
  industrial: '#2e302d',
  protected_area: '#fdc000',
  scrub: '#CBDAAD',
  retail: '#908469',
  railway: '#D24D4D',
  beach: '#CEB44A',
};
